import type { FieldRendererProps } from '../../config/types';
import { Textarea } from '@/components/ui/Textarea';

export function TextAreaRenderer({ field, value, onChange, onBlur, error }: FieldRendererProps) {
  const maxLength = field.resolvedValidations.maxLength;
  const rows = (field.props?.rows as number) ?? 3;

  return (
    <Textarea
      id={field.id}
      value={(value as string) ?? ''}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      placeholder={field.placeholder}
      disabled={field.isDisabled}
      maxLength={maxLength}
      rows={rows}
      aria-invalid={!!error}
      className="resize-vertical"
    />
  );
}
